module.exports = __webpack_public_path__ + "static/checkAutoPenaltiesBannerIos-1f19035153c96286c7d288a7c03bdc2b.png";